const FDIC_LOGO_SRC = '/fdic-logo.png'

export function FdicInsuranceBanner() {
  return (
    <div
      aria-label="FDIC insurance notice"
      className="w-full bg-cfb-light text-center text-[12.8px] font-normal leading-tight text-black"
      role="banner"
      style={{ fontFamily: '"Source Sans Pro", Arial, sans-serif' }}
    >
      <div className="flex min-h-5 items-center justify-center gap-1 px-3 py-0.5">
        <img alt="FDIC logo" className="h-3 w-auto shrink-0" src={FDIC_LOGO_SRC} />
        <span>FDIC-Insured—Backed by the full faith and credit of the U.S. Government</span>
      </div>
      <div
        className="h-1 w-full"
        data-testid="fdic-banner-blue-line"
        style={{ backgroundImage: 'linear-gradient(90deg, var(--cfb-shadow) 0%, var(--cfb-sky) 100%)' }}
      />
    </div>
  )
}
